import { Box } from "@mantine/core"
import classes from "./WebphonePlaceholder.module.css"

interface IWebphonePlaceholderProps {
  webphoneCollapsed?: boolean
}

export function WebphonePlaceholder({ webphoneCollapsed: webphoneExpanded }: IWebphonePlaceholderProps) {
  return <Box data-hidden={webphoneExpanded} className={classes.container} />
}
